import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, RetriggerWebhookResponseDialogueHandler } from './types';
import WebhookContext from './RetriggerWebhookResponseContext';

const { ConfirmationDialogue } = vp;

type WebhookDialogueProps = {
  handleDialogue: DialogueHandler<RetriggerWebhookResponseDialogueHandler>;
};

type FC = FunctionComponent<WebhookDialogueProps>;

const RetriggerWebhookResponseDialogue: FC = ({ handleDialogue }: WebhookDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'RetriggerWebhookResponseDialogue' });
  const { showRetriggerWebhookErrorAlert, retriggerError, showRetriggerSuccessAlert } = useContext(WebhookContext);

  const ErrorMessage =
    retriggerError !== '' ? retriggerError : t('tryAgainMessage', { defaultValue: 'Try again in a few seconds' });

  return useMemo(
    () => (
      <div>
        {/* Retrigger error*/}
        <ConfirmationDialogue
          isVisible={showRetriggerWebhookErrorAlert}
          title={t('errorTitle', { defaultValue: 'Webhook unable to be retriggered.' })}
          status="error"
          subTitle={`${ErrorMessage}`}
          confirm={{
            label: t('backToWebhook', { defaultValue: 'Back to Webhook' }),
            action: () => handleDialogue({ type: 'error', state: 'error' }),
          }}
        />

        {/* Retrigger Success */}
        <ConfirmationDialogue
          isVisible={showRetriggerSuccessAlert}
          title={t('successTitle', { defaultValue: 'Success! The webhook successfully retriggered.' })}
          status="success"
          subTitle={t('successSubTitle', { defaultValue: 'Navigate back to your users.' })}
          confirm={{
            label: t('backToWebhook', { defaultValue: 'Back to Webhook' }),
            action: () => handleDialogue({ type: 'alert', state: 'success' }),
          }}
        />
      </div>
    ),
    [showRetriggerWebhookErrorAlert, showRetriggerSuccessAlert, ErrorMessage, handleDialogue, t],
  );
};

export default RetriggerWebhookResponseDialogue;
